import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import config from '@/config';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import messages from '../documentMessages';
const resolveSite = (link) => api.base
    .get(`${config.appUrls.documents}/api/sharepoint/sites/resolve`, { params: { url: link } })
    .then(x => (x.data ? { key: x.data.id, label: x.data.name } : null));
export const SharepointSiteLinkInput = ({ value, onChange, onLoadingChanged, }) => {
    const intl = useIntl();
    const [link, setLink] = useState('');
    const [loading, setLoading] = useState(false);
    const resolve = (linkToResolve) => {
        const trimmed = linkToResolve.trim();
        if (!trimmed)
            return;
        onChange(null);
        setLoading(true);
        onLoadingChanged === null || onLoadingChanged === void 0 ? void 0 : onLoadingChanged(true);
        resolveSite(trimmed)
            .then(onChange, error => {
            handleHttpError(intl)(error);
        })
            .finally(() => {
            setLoading(false);
            onLoadingChanged === null || onLoadingChanged === void 0 ? void 0 : onLoadingChanged(false);
        });
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "input-group" }, { children: [_jsx("input", { "data-1p-ignore": true, className: "form-control", placeholder: intl.formatMessage(messages.SharepointLinkPlaceholder), value: link, disabled: loading, onChange: e => {
                            setLink(e.target.value);
                            if (value)
                                onChange(null);
                        }, onKeyDown: e => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                resolve(link);
                            }
                        } }), _jsx("span", Object.assign({ className: "input-group-btn" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn btn-default", disabled: loading || !link.trim(), onClick: () => resolve(link) }, { children: _jsx(FormattedMessage, Object.assign({}, messages.ResolveSharepointLink)) })) }))] })), _jsx("span", Object.assign({ className: "help-block" }, { children: value ? (_jsx(FormattedMessage, Object.assign({}, messages.SharepointSiteFound, { values: { name: value.label } }))) : (_jsx(FormattedMessage, Object.assign({}, messages.SharepointLinkHelp))) }))] }));
};
